import React, { useEffect, useState } from "react";
import "./Exercise1Intro.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";
import IconBubble from "../components/IconBubble/IconBubble";
import Star2 from "../components/icons/star2.svg";
import { API_BASE_URL } from "../config";

const Exercise1Intro = () => {
  const [selectedDuration, setSelectedDuration] = useState(0.5); // Default to 1 minute
  const [canStart, setCanStart] = useState(false);
  const [sunnyHTML, setSunnyHTML] = useState(
    `<span style="color: #4B5161; font-family: 'Nunito', sans-serif;">
      This is a breathing exercise to enhance concentration. Focus on your breath's airflow.
    </span>`
  );

  const [userData, setUserData] = useState(null); 
  const navigate = useNavigate();

  const durations = [1, 3, 5, 8, 10]; // List of durations

  // Fetch user progress
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });

        const data = await response.json();
        setUserData(data);

        // ✅ Automatically select the next available duration
        if (data.exercisesUnlocked[0] === 6) {
          setSelectedDuration(10);
        } else if (data.exercisesUnlocked[0] >= 1) {
          const nextUnlocked = durations.find(duration => (durations.indexOf(duration) + 1) >= data.exercisesUnlocked[0]);
          if (nextUnlocked) {
            setSelectedDuration(nextUnlocked);
          }
        }

      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const isLevelUnlocked = (levelNumber) => {
    if (!userData) return false; // Assume locked if user data isn't loaded
    return userData.exercisesUnlocked[0] >= levelNumber;
  };

  const handleDurationClick = (duration) => {
    setSelectedDuration(duration);
  };

  const handleStartClick = () => {
    if (selectedDuration == 1) {
        navigate("/RhythmChoosing", { state: { duration: selectedDuration } });
    } else {
        navigate("/Exercise1Workout", { state: { duration: selectedDuration } });
    }

  };

  let handleNextNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif;">
        You may proceed onto the next exercise after completing the 10-minute stage. You got this!
      </span>`
    );
    setCanStart(true);
  };

  let handleNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif;">
        Gradually increase the above duration after each completion of the exercise.
      </span>`
    );
  };
  

  const renderButton = () => {
    if (canStart) {
      return (
        <button className="guidance-and-start-button" onClick={handleStartClick}>
          Start
        </button>
      );
    } else {
      return (
        <button className="guidance-and-start-button" onClick={
          sunnyHTML.includes("Focus") ? handleNextClick : handleNextNextClick
        }>
          Next
        </button>
      );
    }
  };

  return (
    <div className="exercise1-intro-container">
      <div className="intro-content">
        <div className="duration-selection">
          <h3>Choose Duration (minutes):</h3>
          <div className="duration">
            {durations.map((duration, index) => (
              <button
                key={duration}
                className={`duration-button ${selectedDuration === duration ? "selected" : ""}`}
                onClick={() => handleDurationClick(duration)}
                disabled={!isLevelUnlocked(index + 1)}
                style={{
                  backgroundColor: isLevelUnlocked(index + 1) ? "#4CAF50" : "#CCCCCC",
                  cursor: isLevelUnlocked(index + 1) ? "pointer" : "not-allowed"
                }}
              >
                {duration}
              </button>
            ))}
          </div>
        </div>
        <div className="hint">
          <p>Hint: Complete levels to unlock more!</p>
        </div>
      </div>
      <div className="sunny-intro">
        <img src={Star2} alt="sunny" className="sunny" />
        <IconBubble width={600} height={100} HTML={sunnyHTML} color="FFFFFF" fontSize={24} />
      </div>
      <div className="bottom-buttons">
        <div></div>
        {renderButton()}
      </div>
    </div>
  );
};

export default Exercise1Intro;
